import React from "react";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import {
  AlertData,
  MutedAlertSites,
  MutedAlertCameras,
} from "./alertsInterfaces";
import { handleAlertButtonsFill } from "./handleAlertButtonsFill";
import { NavigateFunction } from "react-router-dom";
import { getActiveIgnoreZones } from "./getActiveIgnoreZones";
import { checkForRedirectAndFetchMP4 } from "./checkForRedirectAndFetchMP4";
import { VlmFilterType } from "./vlmFilters";
import {
  arrowStateForNavigableIndex,
  getNavigableAlerts,
  isSameAlertRow,
  readStoredAlertsTableSort,
} from "./getNavigableAlerts";

export const handleBackButtonClick = (
  selectedRow: any,
  setAlertIndex: Dispatcher<number>,
  setSelectedRow: any,
  alertData: any,
  navigate: NavigateFunction,
  setMP4URL: any,
  setVideoClipLoading: Dispatcher<boolean>,
  setSelectedButtonsFilled: any,
  setSeeMoreURL: Dispatcher<string>,
  setAlertData: any,
  setRefreshingData: Dispatcher<boolean>,
  setSelectedAlertCameraInfo: any,
  setIgnoreZonesSelectedAlert: any,
  alertsIndexOrder: any,
  detectionType: string,
  outcomeFilterType: string,
  setBackArrowDisabled: Dispatcher<boolean>,
  setForwardArrowDisabled: Dispatcher<boolean>,
  setShowRefreshButton: Dispatcher<boolean>,
  mutedAlertSites: MutedAlertSites,
  mutedAlertCameras: MutedAlertCameras,
  getCurrentSelectedRowKey?: () => string | null,
  setVideoProcessing?: Dispatcher<boolean>,
  useAsyncGeneration: boolean = true,
  setSelectedRowRef?: (row: any) => void,
  vlmFilterType: VlmFilterType = "All",
  filterType: string | null = "UNCLAIMED"
) => {
  const storedSort = readStoredAlertsTableSort();
  const filteredAlertData = getNavigableAlerts({
    alertData,
    detectionType,
    outcomeFilterType,
    vlmFilterType,
    showVlmFilters: true,
    mutedAlertSites,
    mutedAlertCameras,
    filterType,
    order: storedSort.order,
    orderBy: storedSort.orderBy,
    applyMuteFilter: true,
  });

  const currentIndex = filteredAlertData.findIndex((alert: any) =>
    isSameAlertRow(alert, selectedRow)
  );

  if (!filteredAlertData || filteredAlertData.length <= 1 || currentIndex < 0) {
    setBackArrowDisabled(true);
    setForwardArrowDisabled(true);
    setRefreshingData(false);
    return;
  }

  const prevIndex = currentIndex - 1;
  if (prevIndex < 0) {
    const arrows = arrowStateForNavigableIndex(
      currentIndex,
      filteredAlertData.length
    );
    setBackArrowDisabled(arrows.backDisabled);
    setForwardArrowDisabled(arrows.forwardDisabled);
    setRefreshingData(false);
    return;
  }

  const prevArrows = arrowStateForNavigableIndex(
    prevIndex,
    filteredAlertData.length
  );
  setBackArrowDisabled(prevArrows.backDisabled);
  setForwardArrowDisabled(prevArrows.forwardDisabled);

  const newSelectedRow = filteredAlertData[currentIndex - 1];
  setSelectedRow(newSelectedRow);
  if (setSelectedRowRef) {
    setSelectedRowRef(newSelectedRow);
  }
  localStorage.setItem("selectedRowAlerts", JSON.stringify(newSelectedRow));
  getActiveIgnoreZones(
    newSelectedRow.camera_pk,
    setSelectedAlertCameraInfo,
    setIgnoreZonesSelectedAlert,
    navigate
  );
  checkForRedirectAndFetchMP4(
    newSelectedRow,
    navigate,
    setMP4URL,
    setVideoClipLoading,
    setShowRefreshButton,
    true,
    getCurrentSelectedRowKey,
    setVideoProcessing,
    useAsyncGeneration
  );
  handleAlertButtonsFill(newSelectedRow, setSelectedButtonsFilled);
  const newAlertData = alertData;
  const newSelectedRowIndex = alertData.findIndex((alert: any) =>
    isSameAlertRow(alert, newSelectedRow)
  );
  if (newSelectedRowIndex < 0) {
    setRefreshingData(false);
    return;
  }
  newAlertData.forEach((object: AlertData) => {
    object.selected = false;
  });
  newAlertData[newSelectedRowIndex].selected = true;
  setSeeMoreURL(newSelectedRow.alert_url);
  setAlertData(newAlertData);
  setRefreshingData(false);
};
